import React from 'react';
import { LoadingContainer, LoadingDot, LoadingDotsColorProps } from './LoadingDots.styles';

interface LoadingDotsProps extends LoadingDotsColorProps {
  loading?: boolean;
}

const LoadingDots = ({
  loading = false,
  background = 'purple',
  loadingDotColor = 'white',
}: LoadingDotsProps): JSX.Element => {
  if (!loading) return null;

  return (
    <LoadingContainer background={background}>
      <LoadingDot
        background={background}
        loadingDotColor={loadingDotColor}
      />
      <LoadingDot
        background={background}
        loadingDotColor={loadingDotColor}
      />
      <LoadingDot
        background={background}
        loadingDotColor={loadingDotColor}
      />
    </LoadingContainer>
  );
};

export default LoadingDots;
